/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/api-v2-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { ContentAiGetContentQueryResponse, ContentAiGetContentPathParams, ContentAiGetContent401, ContentAiGetContent403 } from "../models/ContentAiGetContent";

export function getContentAiGetContentUrl(id: ContentAiGetContentPathParams["id"]) {
  const res = { method: 'GET', url: `/content-ai/v1/contents/${id}` as const }
  return res
}

/**
 * @summary Get content by ID
 * {@link /content-ai/v1/contents/:id}
 */
export async function contentAiGetContent(id: ContentAiGetContentPathParams["id"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<ContentAiGetContentQueryResponse, ResponseErrorConfig<ContentAiGetContent401 | ContentAiGetContent403>, unknown>({ method : "GET", url : getContentAiGetContentUrl(id).url.toString(), ... requestConfig })
  return res.data
}